import { faUser, faPhone, faKey } from '@fortawesome/pro-regular-svg-icons'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { Card, Heading, HeadingVariants, Icon } from '@/ui'
import { Credentials } from './credentials'
import { SmsConsent } from './sms-consent'
import { TwoFactorAuthentication } from './two-factor-auth'

interface SectionCardHeaderProps {
  icon: IconDefinition
  title: string
}

const SectionCardHeader = ({ icon, title }: SectionCardHeaderProps) => (
  <div className="flex items-center gap-4">
    <Icon icon={icon} />
    <Heading variant={HeadingVariants.H2}>{title}</Heading>
  </div>
)

export const AccountTab = () => {
  return (
    <div className="flex flex-col gap-6 max-w-screen-sm">
      <Card className="my-0" childrenClassName="p-6">
        <div className="flex flex-col gap-4">
          <SectionCardHeader icon={faUser} title="Account Details" />

          <div className="w-full md:w-2/3">
            <Credentials />
          </div>
        </div>
      </Card>

      <Card className="my-0" childrenClassName="p-6">
        <div className="flex flex-col gap-4">
          <SectionCardHeader icon={faPhone} title="SMS Consent" />

          <SmsConsent />
        </div>
      </Card>

      <Card className="my-0" childrenClassName="p-6">
        <div className="flex flex-col gap-4">
          <SectionCardHeader icon={faKey} title="Two-factor Authentication" />

          <TwoFactorAuthentication />
        </div>
      </Card>
    </div>
  )
}
